function initializeProductRecommendations(customElementTag) {
  if (!customElements.get(customElementTag)) {
    class ProductRecommendations extends HTMLElement {
      constructor() {
        super();

        // Flag to track if the slider has been initialized
        let sliderInitialized = false;

        // Initialize the slider immediately when the content is loaded
        const initializeSlider = () => {
          if (!sliderInitialized) {
            console.log("Initializing slider...");
            let slider = new KeenSlider(
              ".td-product-recommendations__container1",
              {
                loop: true,
                slides: {
                  perView: 1.5,
                  spacing: 15,
                },
                breakpoints: {
                  "(min-width: 750px)": {
                    slides: {
                      perView: 2.5,
                      spacing: 15,
                      loop: true,
                    },
                  },
                  "(min-width: 1024px)": {
                    slides: {
                      perView: 4,
                      spacing: 15,
                      loop: false,
                    },
                  },
                },
              },
              [navigation]
            );

            sliderInitialized = true; // Mark the slider as initialized
            console.log("Slider initialized successfully");
          }
        };

        function navigation(slider, element) {
          let wrapper, dots, arrowLeft, arrowRight;

          function markup(remove) {
            wrapperMarkup(remove);
            dotMarkup(remove);
            arrowMarkup(remove);
          }

          function removeElement(element) {
            element.parentNode.removeChild(element);
          }

          function createDiv(className) {
            var div = document.createElement("div");
            var classNames = className.split(" ");
            classNames.forEach((name) => div.classList.add(name));
            return div;
          }

          function arrowMarkup(remove) {
            if (remove) {
              removeElement(arrowLeft);
              removeElement(arrowRight);
              return;
            }
            arrowLeft = createDiv("arrow arrow--left");
            arrowLeft.addEventListener("click", () => slider.prev());
            arrowRight = createDiv("arrow arrow--right");
            arrowRight.addEventListener("click", () => slider.next());

            wrapper.appendChild(arrowLeft);
            wrapper.appendChild(arrowRight);
          }

          function wrapperMarkup(remove) {
            if (remove) {
              var parent = wrapper.parentNode;
              while (wrapper.firstChild)
                parent.insertBefore(wrapper.firstChild, wrapper);
              removeElement(wrapper);
              return;
            }
            wrapper = createDiv("navigation-wrapper");
            slider.container.parentNode.appendChild(wrapper);
            wrapper.appendChild(slider.container);
          }

          function dotMarkup(remove) {
            if (remove) {
              removeElement(dots);
              return;
            }
            dots = createDiv("dots");
            slider.track.details.slides.forEach((_e, idx) => {
              var dot = createDiv("dot");
              dot.addEventListener("click", () => slider.moveToIdx(idx));
              dots.appendChild(dot);
            });
            wrapper.appendChild(dots);
          }

          function updateClasses() {
            var slide = slider.track.details.rel;
            slide === 0
              ? arrowLeft.classList.add("arrow--disabled")
              : arrowLeft.classList.remove("arrow--disabled");
            slide === slider.track.details.slides.length - 1
              ? arrowRight.classList.add("arrow--disabled")
              : arrowRight.classList.remove("arrow--disabled");
            Array.from(dots.children).forEach(function (dot, idx) {
              idx === slide
                ? dot.classList.add("dot--active")
                : dot.classList.remove("dot--active");
            });
          }

          slider.on("created", () => {
            markup();
            updateClasses();
            console.log("Slider created");
          });
          slider.on("optionsChanged", () => {
            markup(true);
            markup();
            updateClasses();
            console.log("Slider options changed");
          });
          slider.on("slideChanged", () => {
            updateClasses();
            console.log("Slider slide changed");
          });
          slider.on("destroyed", () => {
            markup(true);
            console.log("Slider destroyed");
          });
        }

        const handleIntersection = (entries, observer) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            observer.unobserve(entry.target);

            console.log("Fetching content...");
            fetch(entry.target.dataset.url)
              .then((response) => response.text())
              .then((text) => {
                const html = document.createElement("div");
                html.innerHTML = text;
                const recommendations = html.querySelector(customElementTag);
                if (
                  recommendations &&
                  recommendations.innerHTML.trim().length
                ) {
                  entry.target.innerHTML = recommendations.innerHTML;
                  console.log("Content loaded successfully.");

                  initializeSlider();
                } else {
                  console.log("No content found.");
                }
              })
              .catch((e) => {
                console.error("Error while fetching content:", e);
              });
          });
        };

        new IntersectionObserver(handleIntersection, {
          rootMargin: "0px 0px 200px 0px",
        }).observe(this);
      }
    }

    customElements.define(customElementTag, ProductRecommendations);
  }
}

initializeProductRecommendations("product-recommendationss");
